export default __webpack_public_path__ + "static/media/hosting3.f878d077.png";